import HelpPortalBanner from '../components/HelpPortalBanner';
import CustomerBenefits from '../components/CustomerBenefits';
import DocumentsGuides from '../components/DocumentsGuides';
import StatsComponent from '../components/StatsComponent';
import AdminButton from '../components/AdminButton';
import { AuthData, ManualItem } from '../types';

interface HomePageProps {
  manualItems: ManualItem[];
  // userIsAdmin?: AuthData['userIsAdmin'];
  loginData: null | AuthData;
  onAddOrEditManual: (data: any, mode: "add" | "edit") => {}
}

const HomePage = ({ manualItems, onAddOrEditManual, loginData }: HomePageProps) => {
  return (
    <>
      <HelpPortalBanner loginData={loginData} />
      <CustomerBenefits />
      {loginData?.UserId && <DocumentsGuides manualItems={manualItems.filter(item => item.isActive && item.locations.documents)} />}
      <StatsComponent
        licensesSold="11.600" 
        clients={2000} 
        yearsInMarket={26} 
        countries={7} 
      />
      {(loginData?.userIsAdmin?.canManageAdmins || loginData?.userIsAdmin?.canManageManuals) && (
        <AdminButton 
          userIsAdmin={loginData?.userIsAdmin}
          manualItems={manualItems}
          adminUsers={[]}
          onAddOrEditManual={onAddOrEditManual}
          onAddOrEditAdmin={() => {}}
        />
      )}
    </>
  );
};

export default HomePage;